import { graphql } from "react-relay";

export const installSlackAppMutation = graphql`
  mutation InstallSlackAppMutation($input: InstallSlackAppMutationInput!) {
    installSlackApp(input: $input) {
      viewer {
        verificationCodeResponse {
          verificationType
          verificationCode
          verificationAttempted
          valid
          slackTeam
          slackUsername
        }
      }
      installSlackAppResult
    }
  }
`;
